"use client";

import React from "react";

import { ChevronLeft, ChevronRight } from "lucide-react";

interface CarouselArrowProps {
  direction: "prev" | "next";
  onClick: (event: React.MouseEvent) => void;
  className?: string;
  size?: "sm" | "md" | "lg";
  style?: React.CSSProperties;
}

const sizeToDims: Record<
  NonNullable<CarouselArrowProps["size"]>,
  { width: string; height: string; icon: string }
> = {
  sm: { width: "w-7", height: "h-9", icon: "w-4 h-4" },
  md: { width: "w-8", height: "h-10", icon: "w-5 h-5" },
  lg: { width: "w-10", height: "h-12", icon: "w-6 h-6" },
};

export function CarouselArrow({
  direction,
  onClick,
  className = "",
  size = "md",
  style,
}: CarouselArrowProps) {
  const dims = sizeToDims[size];
  const base = `${dims.width} ${dims.height} rounded-md bg-white text-gray-900 hover:bg-white shadow-md hover:shadow-lg transition-all duration-200 flex items-center justify-center`;
  const compound = `${base} ${className}`.trim();

  return (
    <button
      type="button"
      aria-label={direction === "prev" ? "Previous image" : "Next image"}
      className={compound}
      style={style}
      onClick={(e) => {
        e.stopPropagation();
        onClick(e);
      }}
    >
      {direction === "prev" ? (
        <ChevronLeft className={dims.icon} />
      ) : (
        <ChevronRight className={dims.icon} />
      )}
    </button>
  );
}

export default CarouselArrow;
